import { BaseEntity } from './BaseEntity';

export class BaseResourceEntity extends BaseEntity {
  description: string;
}
